import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { createAvatar } from '@dicebear/core';
import { avataaars } from '@dicebear/collection';
import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import { userActions } from 'store/modules/user/user-slice';

function AvatarSetupMd() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userProfilePopup = useSelector((state) => state.user.userProfilePopup);

  const avatar = createAvatar(avataaars, {
    seed: 'Eliza',
    radius: 50,
    size: 360,
    backgroundColor: ['b6e3f4'],
    clothingGraphic: ['deer'],
  });

  const svg = avatar.toDataUri();

  const handleProceed = () => {
    dispatch(userActions.setUserProfilePopup({ modal: false }));
    navigate('/me/profile');
  };

  const handleClose = () => {
    dispatch(userActions.setUserProfilePopup({ modal: false }));
  };

  return (
    <Modal
      isOpen={userProfilePopup.modal}
      onClose={handleClose}
      isCentered
      size="xl"
      closeOnOverlayClick={false}
    >
      <ModalOverlay backdropFilter="auto" backdropBlur="2px" />
      <ModalContent>
        <ModalHeader>Update User Profile</ModalHeader>
        <ModalBody>
          <Flex direction="column" gap={6}>
            <Box justifyItems="center">
              <Image src={svg} />
            </Box>
            <Text>
              It looks like you have not customized your profile yet. Click on
              &quot;Proceed&quot; to customize your profile by creating your own
              avatar and updating your gamer tag.
            </Text>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex flex="1" justifyContent="center">
            <Button colorScheme="red" width="250px" onClick={handleProceed}>
              Proceed
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default AvatarSetupMd;
